import userApi from "../../api/user";
import locationApi from "../../api/location";
import { LoginStatus } from "../../utils/constants/navigationConstants"

export default {
    state: {
        userId: null,
        locationId: null,
        notActivatedReason: null,
        email: null,
        securityQuestions: [],
        lastRefresh: 0,
        refreshPeriod: 0
    },
    getters: {
        isAuthorized: state => !!state.userId,
        loginStatus: state => {
            if (!state.userId) return LoginStatus.NotLogged;
            if (state.notActivatedReason) return state.notActivatedReason;
            if (!state.locationId) return LoginStatus.LocationNotAccessed

            return LoginStatus.LocationAccessed
        },
        securityQuestion: state => no => state.securityQuestions.firstOrDefault(q => q.Order === no),
        notActivatedReason: state => state.notActivatedReason
    },
    mutations: {
        clearUserData(state) {
            state.userId = null;
            state.locationId = null;
            state.notActivatedReason = null;
        },
        setClaims(state, claims) {
            state.userId = claims["uid"];
            state.locationId = claims["lid"] ? Number.parseInt(claims["lid"]) : null;
            state.notActivatedReason = claims["notActive"];
            state.lastRefresh = claims["lastRefresh"];
            state.refreshPeriod = claims["refreshPeriod"]
        },
        setUserProfile(state, profile) {
            state.email = profile.Email;
            state.securityQuestions = profile.SecurityQuestions;
        },
        setUserEmail(state, email) {
            state.email = email;
        },
        updateLastRefresh(state) {
            state.lastRefresh = (+new Date()) / 1000;
        }
    },
    actions: {
        async login({ commit, dispatch }, data) {
            var claims = await userApi.login(data);
            commit('setClaims', claims);
            if(claims){
                await dispatch('startMaintenanceNotificationMonitoring');
            }
        },
        async logOff({ commit, dispatch }) {
            await userApi.logoff();
            commit('clearUserData');
            await dispatch('stopMaintenanceNotificationMonitoring');
        },
        async initUser({ state, commit, dispatch }) {
            var claims = await userApi.getClaims();
            commit('setClaims', claims);
            if(claims){
                await dispatch('startMaintenanceNotificationMonitoring');
            }
            if (state.locationId) {
                await dispatch('initLocation');
            }
        },
        async initLocation({ commit, state, dispatch }) {
            if (!state.locationId) {
                commit("clearLocation");
                return;
            }            
            var location = await locationApi.getLocation();
            commit('setLocation', location);
            await dispatch('startTestExpirationMonitoring');
        },
        async initUserProfile({ commit }) {
            var data = await userApi.getUserProfile();
            commit('setUserProfile', data);
        },
        async initUserProfileDirty({ state, dispatch }) {
            if (!state.email) {
                await dispatch('initUserProfile');
            }
        },
        async createPassword({ dispatch }, password) {
            await userApi.createPassword(password);
            await dispatch('initUser');
        },
        async createSecurityAnswers({ dispatch }, data) {
            await userApi.createSecurityAnswers(data);
            await dispatch('initUser');
        },
        async acceptTermsOfUse({ dispatch }) {
            await userApi.acceptTermsOfUse();
            await dispatch('initUser');
        },
        async createUser({ }, data) {
            await userApi.create(data);
        },
        async validateUserName({ }, name) {
            var result = await userApi.userExist(name);
            return result ? "User Name is not available." : "";
        },
        async validateEmail({ state }, email) {
            if (state.email === email) {
                return "";
            }
            var result = await userApi.isEmailUsed(email);
            return result ? "Email is not available." : "";
        },
        async validatePassword({ }, password) {
            var result = await userApi.validatePassword(password);
            return result ? "" : "Current password is incorrect.";
        },
        async getSecurityQuestionByUserName({ }, name) {
            return await userApi.getSecurityQuestionByUserName(name);
        },
        async getSecurityQuestionByEmail({ }, email) {
            return await userApi.getSecurityQuestionByEmail(email);
        },
        async resetPassword({ }, data) {
            return await userApi.restorePassword({
                userName: data.value,
                question: data.question,
                answer: data.answer
            });
        },
        async sendEmailWithUserName({ }, data) {
            return await userApi.sendEmailWithUserName({
                email: data.value,
                question: data.question,
                answer: data.answer
            });
        },
        async getSecurityQuestions() {
            return await userApi.getSecurityQuestions();
        },
        async updatePassword({ }, request) {
            return await userApi.updatePassword(request);
        },
        async updateUserProfile({ commit }, data) {
            await userApi.updateUserProfile(data);
            commit('setUserEmail', data.email);
        }
    }
}